"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertText = exports.TextConversionTypes = void 0;
const _ = __importStar(require("lodash"));
var TextConversionTypes;
(function (TextConversionTypes) {
    TextConversionTypes["Title"] = "Title";
    TextConversionTypes["Upper"] = "Upper";
    TextConversionTypes["Lower"] = "Lower";
    TextConversionTypes["Start"] = "Start";
    TextConversionTypes["Camel"] = "Camel";
    TextConversionTypes["Pascal"] = "Pascal";
    TextConversionTypes["Hyphen"] = "Hyphen";
    TextConversionTypes["Snake"] = "Snake";
    TextConversionTypes["Dot"] = "Dot";
    TextConversionTypes["Sentence"] = "Sentence";
    TextConversionTypes["Unsnake"] = "Unsnake";
})(TextConversionTypes || (exports.TextConversionTypes = TextConversionTypes = {}));
function convertText(value, conversion) {
    if (!Array.isArray(conversion)) {
        conversion = [conversion];
    }
    for (let item of conversion) {
        switch (item) {
            case TextConversionTypes.Title:
                value = value
                    .split(' ')
                    .map((p) => _.startCase(p))
                    .join(' ');
                break;
            case TextConversionTypes.Upper:
                value = value.toUpperCase();
                break;
            case TextConversionTypes.Lower:
                value = value.toLowerCase();
                break;
            case TextConversionTypes.Start:
                value = _.startCase(value);
                break;
            case TextConversionTypes.Camel:
                value = _.camelCase(value);
                break;
            case TextConversionTypes.Pascal:
                value = value
                    .split(' ')
                    .map((p) => _.startCase(p))
                    .join('');
                break;
            case TextConversionTypes.Hyphen:
                value = value.split(' ').join('-');
                break;
            case TextConversionTypes.Snake:
                value = value.split(' ').join('_');
                break;
            case TextConversionTypes.Dot:
                value = value.split(' ').join('.');
                break;
            case TextConversionTypes.Sentence:
                value = value.replace(/\_/g, ' ');
                value = value[0].toUpperCase() + value.substring(1);
                break;
            case TextConversionTypes.Unsnake:
                value = value.replace(/\_/g, ' ');
                break;
        }
    }
    return value;
}
exports.convertText = convertText;
//# sourceMappingURL=conversions.js.map